<p *ngIf="licenseToBeRenewedId" class="mt-0">
  {{ 'DIALOG.ACTIVATE_LICENSE_DIALOG.RENEW_LICENSE_DESC1' | translate }} {{ expirationTime | formatDate: 'P' : true }}.
  {{ 'DIALOG.ACTIVATE_LICENSE_DIALOG.RENEW_LICENSE_DESC2' | translate }}
</p>

{{ 'DIALOG.ACTIVATE_LICENSE_DIALOG.MESSAGE' | translate }}

<div class="mt-3 w-full flex justify-content-center align-items-center flex-column">
  <span class="w-full">
    <label [iosRequired]="true">{{ 'LABELS.LICENSE_KEY' | translate }}</label>
    <input pInputText type="text" class="w-full uppercase mt-1" [(ngModel)]="serialNumber" />
  </span>

  <span class="mt-3 w-full">
    <label [iosRequired]="true">{{ 'LABELS.LICENSE_FILE' | translate }}</label>
    <div class="relative">
      <input #inputFile type="file" class="hidden" (change)="onFileSelected($event)" />
      <input pInputText type="text" readonly class="w-full" [value]="selectedFile?.name ?? ''" />
      <button pButton [label]="'LABELS.CHOOSE_FILE' | translate" class="absolute right-0 p-button-secondary" (click)="inputFile.click()"></button>
    </div>
  </span>
</div>

<div class="mt-3 w-full flex justify-content-end">
  <button [disabled]="!serialNumber || !selectedFile" pButton [label]="'BUTTONS.ACTIVATE' | translate" (click)="offlineActivation()"></button>
</div>
